import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '51吃瓜网今日吃瓜资源 - 在线吃瓜爆料视频每日更新',
  description: '51吃瓜网今日吃瓜资源网站提供最新吃瓜爆料视频每日更新，覆盖网红、主播、博主反差内容，实时追踪黑料大瓜。支持51吃瓜app下载与在线观看入口。',
  url: 'http://baoliaoshe.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '51吃瓜网',
    url: 'http://baoliaoshe.cn/',
  },
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrendingSection />
        <CategoryGrid />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />
    </>
  );
}